import axios from "axios";
import { create } from "zustand";

const heroStore = create((set) => ({
  MAX_FILE_SIZE: 1500,

  heroes: null,
  isLoading: true,

  heroForm: {
    laptopImage: "",
    tabletImage: "",
    mobileImage: "",
    title: "",
    desc: "",
    active: false,
  },

  clearHeroForm: () => {
    set({
      heroForm: {
        laptopImage: "",
        tabletImage: "",
        mobileImage: "",
        title: "",
        desc: "",
        active: false,
      },
    });
  },

  fetchAllHeroes: async () => {
    set({ isLoading: true });
    try {
      // Fetch Heroes
      const res = await axios.get("fetch-heroes");

      // set heroes to state
      if (res.data.heroes.length) {
        set({ heroes: res.data.heroes });
      } else {
        set({ heroes: null });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    } finally {
      set({ isLoading: false });
    }
  },

  fillHeroDataWithName: (e) => {
    const { name, value } = e.target;
    set((state) => {
      return {
        heroForm: {
          ...state.heroForm,
          [name]: value,
        },
      };
    });
  },
  setActiveOnOrOff: (value) => {
    set((state) => {
      return {
        heroForm: {
          ...state.heroForm,
          active: value,
        },
      };
    });
  },
  fillHeroImage: async ({ name, files }) => {
    const { MAX_FILE_SIZE } = heroStore.getState();
    if (MAX_FILE_SIZE < files[0].size / 1024) {
      return false;
    }

    set((state) => {
      return {
        heroForm: {
          ...state.heroForm,
          [name]: files[0],
        },
      };
    });
    return true;
  },

  clearImage: ({ name }) => {
    set((state) => {
      return {
        heroForm: {
          ...state.heroForm,
          [name]: "",
        },
      };
    });
  },

  createHero: async () => {
    const { heroForm, clearHeroForm } = heroStore.getState();
    try {
      // Create the Hero
      var bodyFormData = new FormData();
      bodyFormData.append("title", heroForm.title);
      bodyFormData.append("laptopImage", heroForm.laptopImage);
      bodyFormData.append("tabletImage", heroForm.tabletImage);
      bodyFormData.append("mobileImage", heroForm.mobileImage);
      bodyFormData.append("desc", heroForm.desc);
      bodyFormData.append("active", heroForm.active);

      const res = await axios.post("/create-hero", bodyFormData);

      if (res) {
        clearHeroForm();

        return true;
      }
      return false;
    } catch (error) {
      console.log("error: ", error);
      return false;
    }
  },
}));

export default heroStore;
